import { memo } from 'react'
import { TechSummary } from '../Widgets/types'
import INGauge from '../Widgets/INGauge'
import OuterWidget from '@/components/Common/OuterWidget/OuterWidget'

type MutatedSummary = TechSummary & { name: string }

const GaugeItem = memo(({ item }: { item: MutatedSummary }) => (
  <div className="scale-[0.85] transform">
    <p className="font-base text-center font-medium">{item.name}</p>
    <div className="mt-10 flex justify-center">
      <INGauge radius={100} percent={100} type={item.overall_trend ?? ''} />
    </div>
  </div>
))
GaugeItem.displayName = 'GaugeItem'

const GaugeWidget = ({ summary }: { summary: MutatedSummary[] }) => {
  return (
    <OuterWidget title="Summary">
      <div className="flex flex-col justify-center gap-0 md:flex-row lg:gap-6">
        {summary.map((item, index) => {
          if (!item.overall_trend) {
            return null
          }
          return <GaugeItem key={`${item.name}-${index}`} item={item} />
        })}
      </div>
    </OuterWidget>
  )
}

export default memo(GaugeWidget)
